import { render, staticRenderFns } from "./guardDetail.vue?vue&type=template&id=eb8fd4ca&scoped=true"
import script from "./guardDetail.vue?vue&type=script&lang=js"
export * from "./guardDetail.vue?vue&type=script&lang=js"
import style0 from "./guardDetail.vue?vue&type=style&index=0&id=eb8fd4ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8fd4ca",
  null
  
)

export default component.exports